import { ActionTree } from 'vuex'
import { SavedFiltersState } from './state'
import {
  SavedFiltersMutationTypes,
  SavedFiltersLoadSuccessMutationPayload,
  SavedFiltersLastFilterMutationPayload,
} from './mutations'
import { ResSavedFilter, ReqSavedFilter } from '../../../models/users'
import { RootState } from '../../state'
import usersApiService from '@/services/users'
import {
  SAVEDFILTERS__LOAD,
  SAVEDFILTERS__LOAD_ONE,
  SAVEDFILTERS__CREATE,
  SAVEDFILTERS__UPDATE,
  SAVEDFILTERS__DELETE,
} from '../../actions'

export type RecordingsLoadPayload = {
  limit: number
  offset: number
  expand: string
  sort: string
  filter: string
}

export type RecordingLoadOncePayload = {
  id: string
  expand: string
}

export const actions: ActionTree<SavedFiltersState, RootState> = {
  async [SAVEDFILTERS__LOAD](context, sectionName: string) {
    const response = await usersApiService.getAllSavedFilters(sectionName)
    const payload: SavedFiltersLoadSuccessMutationPayload = response
    context.commit(SavedFiltersMutationTypes.LoadSuccess, payload)
    return response
  },

  async [SAVEDFILTERS__LOAD_ONE](context, data: ResSavedFilter) {
    const response = await usersApiService.getSavedFilter(Number(data.id))
    context.dispatch(SAVEDFILTERS__LOAD, data.section)
    return response
  },

  async [SAVEDFILTERS__CREATE](context, data: ReqSavedFilter) {
    const response = await usersApiService.setSavedFilter(data)
    const payload: SavedFiltersLastFilterMutationPayload = response
    context.commit(SavedFiltersMutationTypes.LastFilter, payload)
    context.dispatch(SAVEDFILTERS__LOAD, data.section)
    return response
  },

  async [SAVEDFILTERS__UPDATE](context, data: ResSavedFilter) {
    const response = await usersApiService.updateSavedFilter(data)
    context.dispatch(SAVEDFILTERS__LOAD, data.section)
    return response
  },

  async [SAVEDFILTERS__DELETE](context, data: ResSavedFilter) {
    const response = await usersApiService.deleteSavedFilter(Number(data.id))
    context.dispatch(SAVEDFILTERS__LOAD, data.section)
    return response
  },
}
